import React, { useState, useRef, useEffect, useCallback } from "react";
import mapboxgl from "mapbox-gl";
import {
  MapWrapper,
  Map,
  MapDimmed,
  MapAbsolute,
  MapArticleWrapper,
  MapArticleBox,
  MapMarkerWrapper,
  MapMarker,
  MapColor,
  MapTitleWrapper,
  MapTitle,
} from "./unit";
import {
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_OPTION,
  MAPBOX_OPTION_ZOOMBIG,
  MAPBOX_OPTION_PARKING,
} from "./constant";
import { POPUP_ARTICLE } from "../asset/article";

export function SectionMapParking() {
  const mapContainer = useRef(null);
  //const [currentMarker, setCurrentMarker] = useState(null);
  useEffect(() => {
    mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
    // eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
    mapboxgl.workerClass =
      // eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
      require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
    mapContainer.current = new mapboxgl.Map({
      container: mapContainer.current,
      ...MAPBOX_OPTION_PARKING,
    });
  }, []);
  return (
    <MapTitleWrapper>
      <Map ref={mapContainer} />
      <MapColor>
        <span className="text">스크롤로 확대/축소해서 볼 수 있습니다.</span>
      </MapColor>
      <MapTitle>
        <span className="title">서울시 공유전동킥보드 불법주차 견인지도</span>
        <span className="remark">
          ** 데이터 제공 : 국회 국토교통위원회 홍기원 의원/ 출처 : 서울시
        </span>
      </MapTitle>
    </MapTitleWrapper>
  );
}

export function SectionMap() {
  const mapParkingContainer = useRef(null);
  const [currentMarker, setCurrentMarker] = useState(null);

  useEffect(() => {
    mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
    mapboxgl.workerClass =
      // eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
      require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
    mapParkingContainer.current = new mapboxgl.Map({
      container: mapParkingContainer.current,
      ...MAPBOX_OPTION,
    });

    if (mapParkingContainer.current) {
      mapParkingContainer.current.on("load", () => {
        mapParkingContainer.current.addLayer({
          id: "gahae",
          type: "circle",
          source: {
            type: "vector",
            url: "mapbox://revernent.cnix7v8p",
          },
          "source-layer": "gahae-8vsjbp",
          paint: {
            "circle-radius": 5,
            "circle-color": "#f2b749",
            "circle-stroke-width": 0,
            "circle-opacity": 1,
          },
        });

        mapParkingContainer.current.addLayer({
          id: "pihae",
          type: "circle",
          source: {
            type: "vector",
            url: "mapbox://revernent.08jhuhn6",
          },
          "source-layer": "pihae-1ap9ql",
          paint: {
            "circle-radius": 5,
            "circle-color": "#06bfbf",
            "circle-stroke-width": 0,
            "circle-opacity": 1,
          },
        });
      });
    }
  }, []);

  useEffect(() => {
    if (mapParkingContainer.current) {
      mapParkingContainer.current.on("click", (e) => {
        const features = mapParkingContainer.current.queryRenderedFeatures(
          e.point,
          {
            layers: ["gahae", "pihae"], // replace with your layer name
          }
        );
        if (!features.length) {
          return;
        }
        const feature = features[0];
        setCurrentMarker(feature?.properties);
        return feature;
      });
    }
  }, [currentMarker]);

  const onCloseMarker = useCallback(() => setCurrentMarker(null), []);

  return (
    <MapMarkerWrapper>
      <MapTitle>
        <span className="title">
          화면을 확대해서 점을 클릭하면 각 사건 정보를 확인할 수 있습니다.
        </span>
      </MapTitle>
      <MapColor>
        <span className="gahae">가해 사건</span>
        <span className="pihae">피해 사건</span>
      </MapColor>
      <Map ref={mapParkingContainer} />
      {currentMarker && (
        <MapMarker>
          <span className="title">이 사건은요? </span>
          <ul className="table">
            <li className="row">
              <span className="row-title">사고일자</span>
              <span className="row-text"> {currentMarker.acdnt_date}</span>
            </li>
            <li className="row">
              <span className="row-title">사고요일</span>
              <span className="row-text"> {currentMarker.dfk_dc}</span>
            </li>
            <li className="row">
              <span className="row-title">사고시간대</span>
              <span className="row-text"> {currentMarker.tmzon_div_1_dc}</span>
            </li>
            <li className="row">
              <span className="row-title">사고장소</span>
              <span className="row-text"> {currentMarker.legaldong_name}</span>
            </li>
            <li className="row">
              <span className="row-title">사고원인</span>
              <span className="row-text"> {currentMarker.lrg_violt_1_dc}</span>
            </li>
            <li className="row">
              <span className="row-title">가해자 연령대</span>
              <span className="row-text"> {currentMarker["ga.age"]}</span>
            </li>
            <li className="row">
              <span className="row-title">피해자 연령대</span>
              <span className="row-text"> {currentMarker["pi.age"]}</span>
            </li>
            <li className="row">
              <span className="row-title">가해자 부상정도</span>
              <span className="row-text"> {currentMarker["ga.injury"]}</span>
            </li>
            <li className="row">
              <span className="row-title">피해자 부상정도</span>
              <span className="row-text"> {currentMarker["pi.injury"]}</span>
            </li>
            <li className="row">
              <span className="row-title">가해피해여부</span>
              <span className="row-text"> {currentMarker.category}</span>
            </li>
          </ul>
          <button className="close" onClick={onCloseMarker}>
            닫기
          </button>
        </MapMarker>
      )}
    </MapMarkerWrapper>
  );
}

export const SectionMapWithArticle = ({ isFixed, moveToUp, moveToDown }) => {
  const [currentMapIdx, setCurrentMapIdx] = useState(0);

  const mapWithArticleContainer = useRef(null);
  const articleScroll = useRef(null);
  const mapPointA = useRef(null);
  const mapPointB = useRef(null);
  const mapPointC = useRef(null);

  const lastMapPoint = useRef(null);

  const refArr = [null, mapPointA, mapPointB, mapPointC, lastMapPoint];

  const handleScroll = useCallback(
    (e) => {
      const lastPosition = lastMapPoint.current.offsetTop - 100;
      const mapPointAPosition = mapPointA.current.offsetTop - 100;
      const mapPonintBPosition = mapPointB.current.offsetTop - 100;
      const mapPonintCPosition = mapPointC.current.offsetTop - 100;
      const currentScroll = e.target.scrollTop;
      if (lastPosition + 400 <= currentScroll) {
        moveToDown();
      } else if (currentScroll === 0) {
        moveToUp();
      } else if (
        mapPointA.current &&
        currentScroll >= mapPointAPosition &&
        currentScroll < mapPonintBPosition
      ) {
        setCurrentMapIdx(1);
      } else if (
        mapPointB.current &&
        currentScroll >= mapPonintBPosition &&
        currentScroll < mapPonintCPosition
      ) {
        setCurrentMapIdx(2);
      } else if (
        mapPointC.current &&
        currentScroll >= mapPonintCPosition &&
        currentScroll < lastPosition
      ) {
        setCurrentMapIdx(3);
      } else if (lastMapPoint.current && currentScroll >= lastPosition) {
        setCurrentMapIdx(4);
      }
    },
    [moveToUp, moveToDown]
  );

  useEffect(() => {
    mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
    mapboxgl.workerClass =
      // eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
      require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
    mapWithArticleContainer.current = new mapboxgl.Map({
      container: mapWithArticleContainer.current,
      center: [127.0260348, 37.50168727],
      ...MAPBOX_OPTION_ZOOMBIG,
    });

    articleScroll.current.scrollTo(0, 200);
    if (mapWithArticleContainer.current) {
      mapWithArticleContainer.current.on("load", () => {
        mapWithArticleContainer.current.addLayer({
          id: "pmPoint",
          type: "circle",
          source: {
            type: "vector",
            url: "mapbox://revernent.26n1r75e",
          },
          "source-layer": "mapScroll-aaluis",
          paint: {
            "circle-radius": 20,
            "circle-color": "#ee3a3a",
            "circle-stroke-width": 4,
            "circle-stroke-color": "#fff",
            "circle-opacity": 1,
          },
        });
      });
    }
  }, []);

  useEffect(() => {
    const mapPoint = [
      {
        longitude: 127.0260348,
        latitude: 37.50168727,
      },
      {
        longitude: 127.0323276,
        latitude: 37.50674193,
      },
      {
        longitude: 127.0335127,
        latitude: 37.52538666,
      },
      {
        longitude: 127.0549366,
        latitude: 37.49674306,
      },
      {
        longitude: 127.0187831,
        latitude: 37.52278574,
      },
    ];

    if (mapWithArticleContainer.current) {
      //  console.log("mapcontainer, flyTo", currentMapIdx);
      mapWithArticleContainer.current.flyTo({
        center: [
          mapPoint[currentMapIdx].longitude,
          mapPoint[currentMapIdx].latitude,
        ],
      });
    }
  }, [currentMapIdx]);
  return (
    <>
      <MapDimmed isFixed={isFixed}>
        <MapWrapper>
          <MapAbsolute ref={mapWithArticleContainer} />
          <MapArticleWrapper ref={articleScroll} onScroll={handleScroll}>
            {POPUP_ARTICLE.map((article, idx) => (
              <MapArticleBox key={article.key} ref={refArr[idx]}>
                <div className="chart">
                  <img src={article.chartImgUrl} alt={article.chartAlt} />
                </div>
                <span className="title">{article.title}</span>
                {article.text.map((text, i) => {
                  return (
                    <span className="text" key={`text-${article.key}-${i}`}>
                      {text}
                    </span>
                  );
                })}
              </MapArticleBox>
            ))}
          </MapArticleWrapper>
        </MapWrapper>
      </MapDimmed>
    </>
  );
};
